import { ReactNode } from 'react';

import * as css from './Pill.css';

type PillProps = {
    children: ReactNode;
    active?: boolean;
    disabled?: boolean;
    onClick: () => void;
};

export const Pill = ({ children, active = false, disabled = false, onClick }: PillProps) => (
    <button
        type="button"
        className={css.pill({ active, disabled })}
        aria-pressed={active}
        disabled={disabled}
        onClick={onClick}
    >
        {children}
    </button>
);
